import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {BigWinView} from '@fantasmagames/slot/src/modules/bigwin/BigWinView';
import {BigWinModule} from '@fantasmagames/slot/src/modules/bigwin/BigWinModule';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

export class BigWinBasicState extends ModuleState<BigWinView, BigWinModule> {
	public onEnterState(): void {
		this.view.hide();
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(FlowModuleEvents.WON_BIG_WIN, this.onBigWinWon);
	}

	protected onBigWinWon(): void {
		this.module.gotoState(BigWinModule.PLAYING_STATE);
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/bigwin/states/BigWinBasicState.ts